import SubscriptionPlans from "../../components/start/suscriptionPlans";
import React from "react";
import HeroLaw from "@/components/start/HeroLaw";


export default function PricingPage() {
  return (
    <div>
     
       <HeroLaw
              titulo=""
              subtitulo="Conéctate con abogados expertos para resolver tus necesidades legales"
              imagenSrc="https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
              imagenAlt="Oficina de abogados moderna"
              botonTexto="Empieza hoy mismo"
              
            />
      <SubscriptionPlans />
    </div>
  )
}

